import React from "react"
import {
	Grid,
	Typography,
	IconButton,
	Button,
	CircularProgress as CircularProgressIcon
} from "@material-ui/core"
import {
	Refresh as RefreshIcon,
	FastForwardOutlined as EnqueuedIcon,
	Repeat as SendingIcon
} from "@material-ui/icons"
import useCustomStyles from "@/styles/custom"
import {
	EditableText,
	Divider
} from "@/components"
import { colors } from "@/styles/colors"
import QueueMetricsCard from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/QueueMetrics/QueueMetricsCard"
import { IProductMessageMetrics } from "@/protocols/metrics"
import useContainerStyles from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/styles"
import { useGlobalStateStore } from "@/store/GlobalState"
import useStyles from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/QueueMetrics/styles"
import DetailedQueueMetrics from "@/pages/Admin/Dashboard/Metrics/ProductMessageMetrics/QueueMetrics/DetailedQueueMetrics"
import HardCoded from "@/services/HardCoded"

type QueueMetricsProps = {
	loading: boolean,
	getMetrics: () => void
	metrics: IProductMessageMetrics
}

const QueueMetrics: React.FC<QueueMetricsProps> = (props) => {
	const {
		loading,
		getMetrics,
		metrics
	} = props

	const customClasses = useCustomStyles()
	const classes = useStyles()
	const containerStyles = useContainerStyles()
	const globalStateStore = useGlobalStateStore()

	const isWabaChannel = globalStateStore.instance.current_channel_type === "waba"

	return (
		<Grid container>
			<Grid item xs={12}>
				<Grid container className={containerStyles.constainerDivision}>
					<Grid item>
						<Typography
							variant="h2"
							color="textPrimary"
							style={{ fontSize: 18 }}
							className={customClasses.uppercase}
						>
							{isWabaChannel ? "FILA DE ENVIO EM MASSA E BOT" : "FILA DE INTEGRAÇÃO, ENVIO EM MASSA E BOT"}
						</Typography>
					</Grid>
					<Grid item>
						<Grid container>
							{HardCoded.checkFeatureFlag("canViewQueueMetrics") && <DetailedQueueMetrics disabled={loading}>
								<Button
									variant="contained"
									className={classes.buttonPrimaryColorOutLined}
								>
										Métricas da fila
								</Button>
							</DetailedQueueMetrics> }
							<Grid item>
								<IconButton
									onClick={() => getMetrics()}
									disabled={loading}
								>
									{loading ? <CircularProgressIcon size={24} /> : <RefreshIcon />}
								</IconButton>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Divider orientation="horizontal" size={2} />
			<Grid
				item
				xs={12}
			>

				<Grid
					container
					spacing={2}
				>
					<Grid
						item
					>
						<QueueMetricsCard
							loading={loading}
							count={metrics?.queueMetrics?.enqueuedMessages || 0}
							countDescription="Mensagens na fila"
							helperText={(
								<>
									<Typography
										component={EditableText}
										code="dashboard_integration_and_message_blast_queue"
										skeletonWidth={200}
										skeletonHeight={100}
									/>
								</>
							)}
							icon={<EnqueuedIcon />}
							iconBackgroundColor={colors.beige[200]}
							mainColor={colors.gray[700]}
							title="Fila"
							showTooltip
						/>
					</Grid>

					<Grid
						item
					>
						<QueueMetricsCard
							loading={loading}
							count={metrics?.queueMetrics?.sendingMessages || 0}
							countDescription="Sendo enviadas"
							helperText={(
								<>
									<Typography
										component={EditableText}
										code="dashboard_integration_and_message_blast_messages_being_sent"
										skeletonWidth={200}
										skeletonHeight={100}
									/>
								</>
							)}
							icon={<SendingIcon />}
							iconBackgroundColor={colors.purple[200]}
							mainColor={colors.gray[700]}
							title="Enviando"
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default QueueMetrics
